import BigWarningIcon from './BigWarningIcon';

export default BigWarningIcon;
